import React, { useEffect, useState } from 'react'
import {
    AccordionSummary,
    AccordionDetails,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../../component/scheduleComps/scheduleList/partList.module.css';
import stylesp from '../prod.module.css';
import { AddCircle, UploadImg } from '../../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { exportManufacturerThunk } from '../../../redux/manufacturer/getAllManufacturerSlice';
import { exportLevel3Thunk } from '../../../redux/level3/getAllLevel3slice';

import Manufacturer1 from './Manufacturer1';
import axios from 'axios';
import api from '../../../utils/api';
import { toast } from 'react-toastify';
import { getTopProductThunk } from '../../../redux/appearanceSlice';
import Manufacturer2 from './Manufacturer2';
import Manufacturer4 from './Manufacturer3';
import Manufacturer3 from './Manufacturer3';
import Manufacturer5 from './Manufacturer5';
import ManufacturerView from './ManufacturerView';


const PopProductView = ({ Accordions, handleChange, expanded }) => {
    const [isOpen, setIsOpen] = useState(false);
    const { exportedData } = useSelector((state) => state.manufacturer);
    const { exportedLevel3 } = useSelector((state) => state.level3);
    const { topproduct } = useSelector((state) => state.appearances)
    const level3 = exportedLevel3?.data
    const manufacturer = exportedData?.data
    const dispatch = useDispatch()

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        dispatch(getTopProductThunk())
        dispatch(exportManufacturerThunk())
        dispatch(exportLevel3Thunk())
    }, [])


    const handleImageUpload = async (e, index, values) => {

        const file = e.target?.files?.[0];
        try {
            if (file) {
                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };

                const { data, status } = await api.getPutSignedUrl(body);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: { "Content-Type": file.type },
                    });

                    const updatedProducts = values?.map((product, idx) =>
                        index === idx
                            ? { ...product, image: data?.data?.url }
                            : product
                    );

                    return updatedProducts

                }
            }
        } catch (err) {
            console.error(err);
            toast.error("Error uploading file");
        }
    };


    return (
        <div>
            <Accordions
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                >
                    <Typography>Popular products</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ margin: "0px 20px 20px 20px", padding: '0px 0px 0px' }}>
                    {topproduct?.data?.length > 0 ?
                    <>
                    {topproduct?.data?.map((i,index)=>(
                        <ManufacturerView
                            manufacturer={manufacturer}
                            level3={level3}
                            handleImageUpload={handleImageUpload}
                            topproduct={i}
                            index={index}
                        />
                    ))
                    }
                        </>
                        :
                        <div>no products found</div>
                    }


                </AccordionDetails>
            </Accordions>
        </div>
    )
}

export default PopProductView